import React from 'react';
import { User, Zap, Bell, Download, Settings, Volume2 } from './Icons';

const Header = ({ 
  streak, 
  onNotificationClick, 
  onAILearningAssistantClick,
  onOfflineModeClick, 
  onSettingsClick,
  onTutorVoiceClick,
  onMenuClick,
  userName = "Peter" 
}) => {
  return (
    <div className="flex justify-between items-center p-6">
      <div className="flex items-center space-x-3">
        {onMenuClick && (
          <button 
            onClick={onMenuClick}
            className="p-2 hover:bg-white/10 rounded-lg transition-all duration-200 ease-out hover:scale-110 active:scale-95"
            aria-label="Open menu"
          >
            <svg className="w-6 h-6 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        )}
        <div className="w-10 h-10 bg-cyan-500 rounded-full flex items-center justify-center">
          <User className="w-6 h-6" />
        </div>
        <div>
          <h1 className="text-xl font-bold">GrammarSpeak</h1>
          <div className="flex items-center space-x-2 text-sm">
            <Zap className="w-4 h-4 text-orange-400" />
            <span className="text-orange-400">{streak} 天連擊</span>
          </div>
        </div>
      </div>
      <div className="flex items-center space-x-3">
        <button 
          className="relative p-2 transition-all duration-200 ease-out hover:scale-110 active:scale-95"
          onClick={onNotificationClick}
        >
          <Bell className="w-6 h-6" />
          <div className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
        </button>
        <button 
          className="p-2 transition-all duration-200 ease-out hover:scale-110 active:scale-95"
          onClick={onAILearningAssistantClick}
        >
          <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center transition-all duration-200 hover:shadow-lg hover:shadow-blue-500/50">
            <span className="text-white text-xs font-bold">AI</span>
          </div>
        </button>
        <button 
          className="p-2 transition-all duration-200 ease-out hover:scale-110 active:scale-95"
          onClick={onTutorVoiceClick}
          title="Change Tutor Voice"
        >
          <Volume2 className="w-6 h-6 text-purple-400" />
        </button>
        <button 
          className="p-2 transition-all duration-200 ease-out hover:scale-110 active:scale-95"
          onClick={onOfflineModeClick}
        >
          <Download className="w-6 h-6" />
        </button>
        <button 
          className="p-2 transition-all duration-200 ease-out hover:scale-110 active:scale-95"
          onClick={onSettingsClick}
        >
          <Settings className="w-6 h-6" />
        </button>
      </div>
    </div>
  );
};

export default Header;
